import { Button } from "@moe/oss/ui/button";
import { Link, useLocation } from "@tanstack/react-router";
import { useMemo } from "react";

export function Sidepane() {
  const menuItems = useMemo(
    () => [
      { path: "/settings/profile", label: "Profile" },
      { path: "/settings/persona", label: "Persona" },
      { path: "/settings/account", label: "Account" },
      { path: "/settings/preference", label: "Preference" }
    ],
    []
  );

  const location = useLocation();

  const activePage = useMemo(() => {
    const matchedItem = menuItems.find((item) => location.pathname.startsWith(item.path));
    return matchedItem ? matchedItem.path : menuItems[0].path;
  }, [location.pathname, menuItems]);

  return (
    <div className="bg-nav-primary ml-3 flex h-full w-56 shrink-0 flex-col space-y-1 overflow-hidden rounded-2xl px-3 py-8 font-extrabold *:rounded-md">
      <h1 className="text-tx-primary flex justify-center text-2xl font-bold tracking-wide">Settings</h1>

      {menuItems.map((item) => (
        <>
          <Link key={item.path} to={item.path}>
            <Button
              variant="ghost"
              className={`flex w-full items-center justify-start space-x-3 p-2.5 text-lg transition duration-300 ease-out ${
                activePage === item.path ? "bg-accent text-tx-primary" : "hover:bg-accent"
              }`}
            >
              {item.label}
            </Button>
          </Link>
        </>
      ))}
    </div>
  );
}
